import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Wallet, ExternalLink } from "lucide-react";
import api, { formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export const PaymentLinkSettings = () => {
  const { user, setUser } = useAuth();
  const [link, setLink] = useState(user?.payment_link || "");
  const [instructions, setInstructions] = useState(user?.payment_instructions || "");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.patch("/auth/profile", { payment_link: link, payment_instructions: instructions });
      setUser(data);
      toast.success("Lien de paiement enregistré");
    } catch (e) {
      toast.error(formatErr(e?.response?.data?.detail) || e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-5" data-testid="payment-link-settings">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-[#618DB8]/10 text-[#618DB8] flex items-center justify-center flex-shrink-0"><Wallet className="h-5 w-5" /></div>
        <div className="flex-1 space-y-3">
          <div>
            <div className="font-display font-bold text-deep">Paiement de mes téléconsultations</div>
            <p className="text-xs text-slate-500 mt-0.5">
              Doctobook n'encaisse aucun honoraire. Indiquez votre lien de paiement personnel (SumUp, PayPal, Lydia Pro, Stripe Payment Link…) :
              il sera proposé au patient à la fin de chaque téléconsultation.
            </p>
          </div>
          <div>
            <Label htmlFor="payment-link" className="text-xs">Lien de paiement (https://…)</Label>
            <Input id="payment-link" value={link} onChange={(e) => setLink(e.target.value)} placeholder="https://pay.sumup.com/b2c/…" data-testid="payment-link-input" />
          </div>
          <div>
            <Label htmlFor="payment-instructions" className="text-xs">Consignes complémentaires (optionnel, ex. virement / RIB sur demande)</Label>
            <Textarea id="payment-instructions" rows={2} maxLength={300} value={instructions} onChange={(e) => setInstructions(e.target.value)} placeholder="Ex. : règlement possible par virement — RIB envoyé par messagerie sécurisée." data-testid="payment-instructions-input" />
          </div>
          <div className="flex items-center gap-3">
            <Button onClick={save} disabled={saving} className="btn-primary" data-testid="payment-link-save-btn">{saving ? "Enregistrement…" : "Enregistrer"}</Button>
            {user?.payment_link && (
              <a href={user.payment_link} target="_blank" rel="noreferrer" className="text-xs text-[#618DB8] hover:underline flex items-center gap-1" data-testid="payment-link-preview">
                Tester mon lien <ExternalLink className="h-3 w-3" />
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
